(function(){
    angular
        .module('appback')
        .directive('compile', compile);

        compile.$inject = ['ResultadosService','$timeout','$compile'];
        function compile(ResultadosService,$timeout,$compile){
            return {
              link: function (scope, element, $attrs) {
                return $timeout(function () {
                  scope.$watch(
                      function(scope) {
                        return scope.$eval($attrs.compile);
                      },
                      function(value) {
                        element.html(value);
                        $compile(element.contents())(scope);
                      });
                })
            }
          }
      }
})();